import ScalarCopy_default from "../ScalarCopy/ScalarCopy.vue.js";
import { LANGUAGE_LABELS } from "./constants.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, defineComponent, mergeModels, mergeProps, normalizeClass, openBlock, renderSlot, toDisplayString, unref, useModel, withCtx } from "vue";
//#region src/components/ScalarCodeBlock/ScalarCodeBlockCopy.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "hidden group-hocus-within/code-block:inline" };
var ScalarCodeBlockCopy_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarCodeBlockCopy",
	props: /*@__PURE__*/ mergeModels({
		showLang: { type: Boolean },
		content: {},
		lang: {},
		copyLabel: {}
	}, {
		"copied": {
			type: Boolean,
			default: false
		},
		"copiedModifiers": {}
	}),
	emits: ["update:copied"],
	setup(__props) {
		const copied = useModel(__props, "copied");
		/** Handles the copy button click */
		const contentToCopy = computed(() => {
			return typeof __props.content === "string" ? __props.content : JSON.stringify(__props.content, null, 2);
		});
		/** Type guard to check if the language is a standard language */
		const isStandardLanguage = (lang) => lang in LANGUAGE_LABELS;
		/** The human readable language name shown next to the copy label */
		const langLabel = computed(() => {
			if (!__props.lang) return;
			return isStandardLanguage(__props.lang) ? LANGUAGE_LABELS[__props.lang] : __props.lang;
		});
		/**
		* Names the button in every state, including while its visible label is `display: none`.
		* The language is included only when it is shown, so the name always contains the visible text
		* (WCAG 2.5.3) and request and response buttons on one page get distinct names.
		*/
		const accessibleName = computed(() => {
			if (__props.copyLabel) return __props.copyLabel;
			return __props.showLang && langLabel.value ? `Copy ${langLabel.value} code` : "Copy code";
		});
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ScalarCopy_default), mergeProps({
				copied: copied.value,
				"onUpdate:copied": _cache[0] || (_cache[0] = ($event) => copied.value = $event),
				"aria-label": accessibleName.value,
				content: contentToCopy.value,
				placement: "left",
				showLabel: ""
			}, { ...unref(cx)(copied.value ? "opacity-100" : "opacity-0 group-hocus-within/code-block:opacity-100") }), createSlots({
				backdrop: withCtx(() => [renderSlot(_ctx.$slots, "backdrop")]),
				_: 2
			}, [__props.lang ? {
				name: "copy",
				fn: withCtx(() => [createElementVNode("span", _hoisted_1, [__props.showLang ? (openBlock(), createElementBlock("span", {
					key: 0,
					class: normalizeClass(["group-hocus/copy-button:sr-only", { capitalize: !isStandardLanguage(__props.lang) }])
				}, toDisplayString(langLabel.value), 3)) : createCommentVNode("", true), createElementVNode("span", { class: normalizeClass({ "group-hocus/copy-button:not-sr-only sr-only": __props.showLang }) }, "Copy", 2)])]),
				key: "0"
			} : void 0]), 1040, [
				"copied",
				"aria-label",
				"content"
			]);
		};
	}
});
//#endregion
export { ScalarCodeBlockCopy_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarCodeBlockCopy.vue.script.js.map